<template>
    <div>
        <div class="headline-small">
            <strong>{{ $t(`reviews.list.labelGiven`) }}</strong>
        </div>

        <div
            v-for="(reviewCycle, index) in reviews.slice(0, limit)"
            :key="`${reviewCycle._id}-${reviewCycle.type}-${index}`"
            class="row"
        >
            <l-reviews-assessments-list-item :review-cycle="reviewCycle" />
        </div>

        <div v-show="reviews.length > limit" class="row" style="margin-bottom: -10px">
            <div class="col-xs-12 text-center">
                <button class="btn btn-primary" @click="limit = 500">
                    <span class="fal fa-chevron-down"></span>
                    <span class="l-default-margin-s">
                        {{
                            $t(`reviews.list.btnShowMore`, {
                                count: reviews.length - 4,
                            })
                        }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import LReviewsAssessmentsListItem from "@/components/LReviewsAssessmentsListItem";

export default {
    components: {
        LReviewsAssessmentsListItem,
    },
    props: {
        reviews: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            limit: 4,
        };
    },
};
</script>
